//The main contact number for kings which will show on any alerts or you can relate to in languages using the 'telephone' variable.
var telephone = "0114 263 2160";

const misc = { telephone_link: '<a href="tel:'+telephone+'"> '+telephone+' </a>', telephone }

export default {
	global: {
		//Text to be used for the header button which will redirect the user to the login screen
		button_login: 'Sign in',
		telephone
	},
    miscellaneous: {

		something_went_wrong: 'Something has gone wrong. Please try again or contact support on ' + misc.telephone_link,

		blank_screen_help_msg: "If you're having issues with blank screen or error message, please try private / incognito mode. Please call " + misc.telephone_link,

		//Text to be used on titles for each page
		page_headings: {
			booking: {
				//venue/{venue_id}
				select_age: 'Select an age group',
				//venue/{venue_id}/weeks
				select_weeks: 'Select a week',
				//venue/{venue_id}/packages
				select_base_programme: 'Select a programme',
				//venue/{venue_id}/packages/choose
				select_days: 'Select your days',
				//venue/{venue_id}/packages/choose
				select_package: 'Select a package',

				//venue/{venue_id}/child/{child_id}/quickadd
				quick_add: 'Quick add',
				//account/bookings/{booking_id}/edit/booking_item_id}
				edit_booking_item: 'Edit booking'
			},
			auth: {
				//signin
				login: 'Login',
				//signup
				signup: 'Register',
				//forgotten-password
				forgotten_password: 'Reset my password'
			},
			cart: {
				//checkout/basket
				view_basket: 'Basket',
				view_booking_payment_confirmation: 'Booking confirmation',
				//checkout/basket/account
				confirm_account_details: 'Confirm your details',
				//checkout/basket/children
				confirm_participant_details: 'Confirm child details:',
				//checkout/payment
				select_payment_method: 'Confirm basket'
			},
			account: {
				//account
				overview: 'My account',
				//account/membership
				view_membership: 'Membership card',
				//account/details
				update_account_details: 'Account details',
				//account/payments
				view_all_payments: 'Payments',
				//account/children
				view_all_children: 'Children',
				//account/bookings
				view_all_bookings: 'Bookings',
				//account/bookings/{booking_id}
				booking_overview: 'Booking Overview',

			}
		},

		//Text to be used on the flash message when the user is currently editing a booking, use :id to mention the ID of the original booking ID
		text_editing_booking_warning: 'You are currently editing booking #:id',
		//Text to be used on the button in the flash message which will discard all the changes made to the current edit
		button_editing_booking_discard_changes: 'Discard changes',

		header: {
			text_call_us_on: 'Call '+misc.telephone,
		},

		footer: {
			//Text to be used for the copyright text in the footer of the page
			text_copyright: 'Kings Camps is part of Kings Active Foundation, a UK registered charity (1105460/SC043119). <br />© ' + (new Date()).getFullYear() + ' Kings Active Foundation.',
            //Text to be used as title for the Terms and Conditions link
            text_terms_and_conditions: 'Terms and conditions',
            //Text to be used as title for the Privacy Policy link
            text_privacy_policy: 'Privacy policy',
            //Text to be used as title for the Contact us link
            text_contact_us: 'Contact us',

			//Text to be used as a prefix before the actual contact number in the footer
			text_telephone_number_prefix: 'Call us on',
		}
	},
	booking: {

        /**
         * Age Selection
         *
         * /venue/{venue_id}
         */
		ages: {
			text_empty: 'There are not programmes available at this venue at the moment. To find out when these will be available, please call us on '+misc.telephone_link+'.'
		},
	    /**
	     * Weeks Selection
	     *
	     * /venue/{venue_id}/weeks
	     */
		weeks: {
			//Text used when there are no weeks available for the given age at the current venue for children under 4 years old
            text_empty_4_years: 'Our programmes are typically designed for children aged 5+ but 4 year olds in full-time education may be eligible. Please give us a call for more details on ' + misc.telephone_link,
			//Text used instead of the above when the child is 4+ years old
			text_empty: 'Sorry we couldn\'t find any dates running at this venue to book online. Please give us a call on ' + misc.telephone_link + ' and we will see what availability we have in your area.'
		},

	    /**
	     * Base package Selection
	     *
	     * /venue/{venue_id}/packages
	     */
	     base_packages: {
	     	//Text used when there are no packages available to choose from
	     	text_empty: 'There are no programmes available with your selection. Please try again  later or call us on ' + misc.telephone_link + ' for more information.',
            //Text used instead of the above when the child is 4+ years old
            text_empty_4_years: 'We currently have no programmes available for 4 or under. If you would like to discuss this further, please call ' + misc.telephone_link + ' for more information',
	     	//Text used on the buttons for a package for packages which are on sale
	     	button_on_sale: 'Select this programme',
	     	//Text used on the buttons for a package for packages which are call to book
	     	button_call_to_book: 'Call ' + misc.telephone_link + ' to book',
			//Text used on ribbons for SOLD OUT
			ribbon_sold_out: 'SOLD OUT',
			//Text used on ribbons for Call to Book
			ribbon_call_to_book: 'Call ' + misc.telephone_link + ' to book',
			//Text used on the buttons for a package which has been sold out
	     	button_click_to_subscribe: '<a target="_blank" href="https://forms.office.com/e/NGT3dGd1Ms">This week is now SOLD OUT - please click here to <b>join our WAITING LIST</b></a>',
			//Text used on the buttons for a multi active package which has been sold out
			button_click_to_subscribe_multi_acitve: '<a target="_blank" href="https://forms.office.com/e/NGT3dGd1Ms">The FULL WEEK programme is SOLD OUT - you can switch to FLEXIBLE BOOKING to see if we have any 3 or 4 day availability or <b>Join our WAITING LIST</b></a>'
	     },

	    /**
	     * Package Selection
	     *
	     * /venue/{venue_id}/packages/choose
	     */
	     packages: {
	     	//Text to be used when there are no programmes available with the selected week, age and base package
			text_empty: 'Sorry, we are struggling to find you suitable programme. Please call us on ' + misc.telephone_link + ' to make your booking.',

	     	//Text used on the header of the hour selection section of the form
	     	text_times_title: 'Select an hour',
	     	//Text used on the header of the programme selection section of the form
	     	text_programme_title: 'Select a package',
			//Text used on the header of the programme availability
	     	text_availability_title: 'Availability',
			// Text used to display notes on venue
			text_notes_title: 'Notes',
	     	//Text to be used on the header of participant selection section of the form
	     	text_participant_title: 'Who\'s attending?',

	     	//Text to be used on the description of whos attending
	     	text_participant_description: 'Already have an account? Sign in to be able to quick-select your children without having to enter their details again.',
	     	//Text to be used on the button for quick adding a participant
	     	button_quick_add_child: 'Quick add child',
            //Text to be used for the label on the child's first name for quick add
            text_child_first_name: 'Child\'s first name',
            //Text to be used for the label on the child's last name for quick add
            text_child_last_name: 'Child\'s last name',
            //Text to be used for the label on the child's date of birth for quick add
            text_child_date_of_birth: 'Child\'s Date of birth',
	     	//Text to be used for when a child that is already created is not old enough or too old for the current package
			text_existing_child_wrong_enough: 'Child will not be correct age',
	     	//Text to be used next to the age of a child
			text_child_years_old: ' years old',

			//Text to be used on a package which is the package already existing when editing an item
			text_current_selection: 'Current selection',
	     	//Text to be used on a package which involves no add ons
			text_regular_package: 'Most Popular',
	     	//Text to be used on a package which contains addons and where a choice is available
			text_addon_package_choice: 'Extra Value Option',
	     	//Text to be used on a package which involves addons but is the only package available with the selected criteria
			text_alternative_option: 'Alternative Option',
	     	//Text to be used when a package has been automatically selected due to their only being one available but may contain addons (Use ":package" to show the name of the selected package
			text_automatic_selection_warning: 'Unfortunately we don\'t offer just the :package alone at the time you\'ve selected. We\'ve automatically selected the closest package for you which may include an additional addon programme.',

	     	//Text to be used to represent a row of dates that are call to book
	     	text_individual_days_call_to_book: 'Call 0114 263 2160 to book the',
	     	//Text to be used to represent a row of dates that are sold out
			text_individual_days_sold_out: 'are SOLD OUT',
			//Text to be used to represent form to subscribe to notify availability
			text_subscribe_to_notify: 'Please consider switching to Flexible Bookings or <a target="_blank" href="https://forms.office.com/e/NGT3dGd1Ms"> complete the form here to join our waiting list</a> If a place becomes available, we’ll be in touch.',
			//Text to be used to represent form to subscribe to notify availability on flexible booking weeks
			text_subscribe_to_notify_short_week: '<a style="color: white" target="_blank" href="https://forms.office.com/e/NGT3dGd1Ms">If any of your preferred days are sold out, please join our waiting list here. We’ll be in touch if a place becomes available.</a>',
			//Text to be used to represent a row of dates that are cancelled
			text_individual_days_cancelled: 'are cancelled',

	     	//Error to be shown when neither a participant or package is selected on the form
	     	text_error_package_and_participant: 'Please select a package and a child to continue',
		    //Error to be shown when a package hasn't been selected but a participant has
	     	text_error_package: 'Please select a package to continue',
			//Error to be shown when a day on individual days hasn't been selected but a participant has
			text_error_days: 'Please select a day to continue',
	     	//Error to be shown when a participant hasn't been selected but a package has
	     	text_error_participant: 'Please select a child to continue',
	     	//Error to be shown when an hour hasn't been selected
            text_error_hours: 'Please select your hours to continue',
			//Tooltip text for CTB bookings
			text_ctb_tooltip: 'Call us on 0114 263 2160',

		//Text to be shown when children have been removed from the booking after selecting dates which they are not old enough to attending
		text_error_child_removed_from_booking: 'Children have been removed from this booking as they will not be old enough to attend! Please check your booking.',

	     	//Text used on the pricing of a single package to show the price after discounts/fees
	     	text_total_price: 'Price',
	     	//Text used on the pricing of a single package to show the price before discounts/fees
	     	text_original_price: 'Package Price',

			//Text to used at the top of the page when on full week booking, to prompt to switch to individual days
	     	text_switch_to_individual_days: '<b>Switch to Multi Active</b>',
	     	//Text to used at the top of the page when on individual day booking, to prompt to switch to full weeks
	     	text_switch_to_full_weeks: '<b>Switch to Rookie Academy</b>'
	     },
	     text_error_short_weeks: 'Unfortunately there has been an error with this booking.'
	},
    /**
     * Cart || Booking Overview
     *
     * /checkout/basket || account/bookings/{booking_id}
     */
	basket: {
		//Text used on the basket for the price of a booking after the discounts/fees have been applied
		text_total_cost: 'Total Booking Cost',
		//Text used on the basket for the price of a booking before the discounts/fees have been applied
		text_original_total: 'Sub-Total',
		//Text used on the baasket to show how much the user has already paid towards this booking
		text_total_payments_received: 'Already Paid',
		//Text used on the basket to show how much is left to pay on a booking if the value is higher than 0 (not refund)
		text_outstanding_total: 'Left to pay',
		//Text used on the basket to show how much of a refund is being given to the user (if the oustanding balance is less than 0)
		text_refund_total: 'Refund Due',
		//Text to be used on the button when checking out from the basket to confirming account details
		button_basket_checkout: 'Checkout',

		//Text used on the button to be redirected back to the age selection screen to add a new child
		button_add_more_children: 'Add other children',
		//Text used on the button to use the quick add process on the current child
		button_quick_add_more: 'Quick add more days/weeks',

		//Text used for the placeholder of the promo code input when a promo code isn't already on the booking
		text_promo_placeholder: 'Enter promo code here',
		//Text used for the button to add a new promo code onto the current booking
		button_promo_submit: 'Apply Promo Code',
		//Text used for displaying results of promocode
		text_promo_submit_success: 'The promo code has been successfully added!',
		text_promo_submit_failed: 'The promo code you entered cannot be found!',
		text_promo_submit_superseded: 'It looks like you already have a better promo code applied!',

		//Text used for the placeholder of the donation when a promo code isn't already on the booking
		text_donation_placeholder: 'Enter donation amount here',
		//Text used for the button to add a donation onto the current booking
		button_donation_submit: 'Add Donation',
		//Text used for the button to add no donation onto the current booking
		button_no_donation: 'No, Thank You!',
		//Text used to describe the donation
		text_donation_description: 'Please consider making a donation to our Supporting Families programme, which benefits the lives of children and families through sport and activity, by offering subsidised places to families in difficult circumstances in your community. Read more <a href="https://www.kingscamps.org/donate" target="_blank">here<a> <br><br>',
		//Text used as footer in donation box
		text_donation_footer: 'Kings Camps is part of Kings Active Foundation, a UK registered charity 1105460/ SCO43119 and with the Fundraising Regulator.',
		//Text used to highlight the donation
		text_donation_description_highlight: 'Please donate to our Supporting Families programme',
		//Text for button to add a donation
		text_button_donation: 'Please click here to add a donation',
		//Text used for the placeholder of the donation when a promo code isn't already on the booking
		text_donation_message: '',
		//Text used for displaying results of donation
		text_donation_required: 'Please choose any amount as your donation! If you wish to proceed without the donation, please choose No to continue further',
		// Text used for selecting gift Aid option
		text_giftaid_required: 'Please select whether you want to add Gift Aid.',
		text_donation_submit_success: 'Thank you! Your donation has been successfully added to the booking!',
		text_no_donation_submit_success: 'Thank you!',
		text_donation_submit_failed: 'Sorry, the donation could not be added!',
		text_donation_submit_superseded: 'It looks like you already have a donation added!',

		text_item_remove_alert: 'Item has been removed from your basket',

		text_item_restore_alert: 'Item has been restored',

		quick_add_edit: {
            //Text to be used when there are no individual days available on quick add
            text_empty_individual_days: 'There are no flexible bookings available at this venue. For more information call us on ' + misc.telephone_link,

            //Text to be used when there are no weeks available on quick add
            text_empty_weeks: 'There are no weeks available at this venue currently. For more information call us on ' + misc.telephone_link,

            //Text to be used as a title for the venue input on quickadd/quickedit
            text_heading_venue: 'Venue',

            //Text to be used as a description for the venue input on quickadd/quickedit
			text_change_venue: 'If you would like to change the venue',
            //Text to be used as a warning that the booking will be deleted when changing a venue/child
            text_change_venue_participant_warning: 'By doing so, this item on your booking will be automatically removed.',

            //Text to be used as a title for the participant input on quickadd/quickedit
			text_heading_participant: 'Child\'s name',
            //Text to be used as a description for the participant input on quickadd/quickedit
			text_change_participant: 'If you would like to select a different child',

			//Text to be used when an item has been added to the basket using quick add
			text_item_added: 'Item has been added to your basket',
			//Text obe used when multiple items have been added to the basket using quick add
			text_item_added_plural: 'Items have been added to your basket'
		},

		confirmation: {
			text_thank_you: 'Thank you!',
            text_thank_you_cancelled: ':-(',

			text_booking_successful: 'Your booking was successful',
			text_booking_cancelled: 'Your booking was cancelled',
			text_booking_edited: 'Your booking was edited',

			//Social Media tokens available:
			//%VENUE-NAME%         					The venue name.
			//%VENUE-TOWN%         					The venue town.
			//%VENUE-SLUG%         					The venue slug (it’s in the venue blueprint, it lets us know that the URL is to the WordPress venue page).
			//%CHILD-NAMES%        					A list of the first names of all children on the booking in a readable format. I.e.: “Steve, Alex and Sarah” or just “Steve” if there is only one.
			//%FIRST-CHILD-NAME%   					The first name of the first child on the booking.
			//%FIRST-CHILD-MONTH-NEXT-ATTENDING%    For the first child, what is the month that they are next attending (based on this booking). It will allow us to say “Steve will be going to Kings Camps in October, want to join him?”
			//%FIRST-CHILD-PACKAGE-TEMPLATE-NAME%   The name of the first package templates the first child has booked on. So if they book Flexicare and Multi-Active, whatever comes first on their booking list. “I’ve booked Steve on Multi-Active Plus with Kings camps this October. Want to join him…”

			text_facebook_share_quote: 'I have just booked %CHILD-NAMES% onto Kings Camps at %VENUE-NAME% (%VENUE-TOWN%).',
			text_facebook_share_url: 'http://www.kingscamps.org/',
			facebook_app_id: 179941722063732,

			text_twitter_tweet: 'I have just booked %FIRST-CHILD-NAME% onto @KingsCamps at %VENUE-NAME% (%VENUE-TOWN%). Who else is going? https://www.kingscamps.org',

			text_social_header: 'Share with friends and family',
			text_social_description: 'Why not let your family and friends know that you have booked?'
		},

		//Text used for the button for editing an existing booking
		button_edit_booking: 'Edit booking',

		//Text used for showing the state of the booking being viewed
		text_booking_state_description_prefix: 'Booking state: ',

		//Text to be used when the basket is currently empty
		text_empty_basket: 'You have no items in your basket',
		text_empty_basket_line_2: 'Click here to start!',

		text_payment_description_single_payment: 'Single payment on the date of purchase',
		text_payment_description_staged_payment: 'A series of monthly payments',
		text_payment_description_childcare_vouchers: '<strong>Childcare Vouchers</strong><br>Registered on the voluntary register with Ofsted means we can accept all childcare vouchers for full or part payment in England. Vouchers must be received 4 weeks prior to prevent your card being charged. Any remaining balance not received via vouchers will be taken from the card provided at the time of booking on the deadline date detailed below. If your booking within 4 weeks of camp starting, payment will be required in full. Payments made via vouchers after a payment has been taken from your card will be refunded. <a target="_blank" href="https://www.kingscamps.org/ccv/">Find out how to send us your vouchers.</a><br><br><strong>Tax Free Childcare Vouchers</strong><br>We accept Government Tax-Free childcare and Childcare Grant Payment Service for full or part payment in England. Payment must be received 4 weeks before camp starts otherwise your card will be charged. If camp is less than 4 weeks away, you will be required to pay in full and we will refund your card once your payment has been received. <a target="_blank" href="https://www.kingscamps.org/childcare-vouchers/">Find out how to make payments here. </a>',
		text_future_planned_payment: 'Scheduled',
        text_future_planned_refund: 'Refunded'
	},
    /**
	 * Account Overview
	 *
	 * /account
     */
    account: {
    	//Text to be used on the button that links to a list of all the current users bookings
    	button_list_bookings: 'Bookings',
        //Text to be used on the button that links to a new booking process
        button_new_booking: 'New Booking',
        //Text to be used on the button that links to a preview of the users membership card
        button_membership_card: 'Membership Card',
        //Text to be used on the button that links to a list of all the current users payments
        button_list_payments: 'Payments',
        //Text to be used on the button that links to a list of all the current users children
        button_list_children: 'Children',
        //Text to be used on the button that links to where the user can update any details on their account
        button_update_account_details: 'Account Details',

        /**
		 * Account Bookings
		 *
		 * /account/bookings
         */
    	bookings: {
    		text_tab_future_bookings: 'Current Bookings',
			text_tab_expired_bookings: 'Expired Bookings',
			text_tab_cancelled_bookings: 'Cancelled Bookings',

            text_tab_bookings_empty: 'You have no bookings on your account',

			text_table_date_heading: 'Dates attending',
			text_table_child_heading: 'Child\'s Name',
			text_table_venue_heading: 'Venue'
		},

        /**
		 * Account Children
		 *
		 * /account/children
         */
		children: {
            //Text to be used before the child's date of birth on the account children section
            text_date_of_birth_prefix: 'D.O.B: ',
			//Text to be used before the date the child is next on camp on the account children section
			text_next_on_camp_prefix: 'Next on camp',
			//Text to be used on the children's page on account section when a child has no future bookings they are attending
			text_no_future_bookings: 'No future bookings',

			//Text to be used on the button which will redirect to the child form where they can update a child's details
			button_update_child_details: 'Update',

			//Text to be used when there are no children on the current account
			text_children_empty: 'You have no children on your account'
		},

        /**
		 * Membership Card
		 *
		 * /account/membership
         */
        membership: {
        	//Text to be used at the top of the membership card as a header
        	text_membership_card_title: 'Membership Card',

			//Text to be used before the number is displayed on the membership card
			text_membership_number_prefix: 'Membership No.',

			//Text to be used as a header at the top of the list of children on the account
			text_membership_card_children_title: 'Children'
		},

        /**
		 * Account Payments
		 *
		 * /account/payments
         */
        payments: {
        	//Text to be used when there are no payments on the current account
        	text_payments_empty: 'You have no payments on your account',
		},

        /**
		 * Register | Login | Account Update
		 *
         */
		register: {
    		//Text for the error message when the password does not contain one uppercase, lowercase and number.
    		text_password_error_message: 'The password must contain at least one lower and upper case character and a number',

			text_title_label: 'Title',
            text_first_name_label: 'First Name',
			text_last_name_label: 'Last Name',
			text_military_service_type_label: 'Military Service',
			text_military_service_number_label: 'RN/RM Service Number',
			text_military_service_rank_label: 'RN/RM Service Rank',
			text_mobile_label: 'Mobile Number',
			text_mobile_label_placeholder: 'Please ensure that this number is available for if we need to contact you about your child on camp',
			text_day_telephone_label: 'Day Telephone',
			child_relationship_label: 'Relationship to Child',
			text_postcode_label: 'Postcode',
			text_zipcode_label: 'Zip code',
			text_address_1_label: 'Address 1',
			text_address_2_label: 'Address 2',
			text_town_label: 'Town',
			text_county_label: 'County',
			text_state_label: 'State',
			text_country_label: 'Country',
            text_email_address_label: 'Email Address',
            text_confirm_email_address_label: 'Confirm Email Address',
            text_password_label: 'Password',
            text_confirm_password_label: 'Confirm Password',
			text_traffic_source_label: 'Where did you hear about us?',
			text_add_nominee_label: 'Would you like to add a nominee to your bookings? Please add the details below',
			text_nominee_name_label: 'Nominee Name',
			text_nominee_contact_label: 'Nominee Contact',
			text_nominee_relationship_label: 'Relationship with Nominee',

/*
			text_optin_line_1: 'We like to keep our communication to the essentials. We will send you camp details, statements and new programme inforamtion by email and (very occassionally) by text, phone or post. If you\'d prefer to change your communication preferences please :clickHere to change.',
			text_optin_line_2: 'We will always contact you by email, phone or text for changes regarding your booking, or in emergencies regarding your children. For other information, select your preferred communication methods:',
			text_optin_option_email: 'By email for infromation about your account, camp, dates and prices.',
			text_optin_option_sms: 'By text message for last minute changes or information.',
			text_optin_option_post: 'By post for new programmes, dates or prices you might want to ask questions about.',
			text_optin_option_phone: 'By phone for new programmes, dates or prices you might want to ask questions about.',
*/

            text_optin_line_1: 'We like to keep our communication to the essentials. We will send you camp details, statements and new programme information by email and (very occasionally) by text.',
            text_optin_line_2: 'Please select your preferred communication methods:',
            text_optin_option_email: 'By email for information about your account, camp, dates and prices.',
            text_optin_option_sms: 'By text message for last minute changes or information.',
            text_optin_option_post: 'By post for new programmes, dates or prices you might want to ask questions about.',
            text_optin_option_phone: 'By phone for new programmes, dates or prices you might want to ask questions about.',
			text_optin_option_whatsapp: 'By whatsapp for information about your account, camp, dates and prices.',
            text_optin_line_3: 'You can change your preferences at any time by updating your account. You can view our Privacy Policy :clickHere.',
            text_optin_line_4: 'You can unsubscribe at any time from our marketing emails by clicking the unsubscribe feature on the email.',
            text_optin_line_5: '(We will always contact you by email, phone or text for changes regarding your booking, or in emergencies regarding your children)',

			text_forgotten_password: 'I\'ve forgotten my password',

			button_request_password: 'Reset my password',
			text_alert_request_password_email_sent: 'An email has been sent to :email with a reset link',
			text_alert_request_password_error: 'There was a problem sending a reset link',
			text_alert_password_updated: 'Your password has been updated.',
			text_alert_password_invalid_code: 'The reset code provided is no longer valid. Please submit a request again.',
			text_alert_password_error: 'There was a problem resetting your password. Try again later.',

			button_login: 'Login',
			text_info_sign_up_description: 'Existing members can sign in for saved details. For non members, please enter details below.',
			text_alert_logged_in: 'Welcome back. You have been logged in!',
			text_alert_wrong_details: 'Email and password did not match any account',

			text_alert_decision_title: 'We notice you have another booking in your basket. Which basket would you like to proceed with?',
			text_alert_decision_edit_warning: 'This booking is an edit of an already existing booking. Not choosing this booking will discard any changes you have made.',

		}
	},

    /**
     * Complete Participant Form
     *
     * /checkout/basket/children
     */
     participant: {
     	form: {
			//Text to be used on the alert when provide the ?notify=true query along with updating a child
			text_notify_alert: 'Please confirm your child\'s details below <small>* indicates a required field</small>',
     		text_error: 'There was a problem confirming the child. Check the form for errors!',
     		text_success: 'The child\'s details have been updated successfully!',

			text_expanded_form_description: 'We need to know more about your child before they can come to camp, you can either fill this in now or later.',
			button_expanded_form_text: 'Fill in more details about your child...',

     		first_name: {
     			label: 'First Name',
     			prompt: '',
     		},
     		last_name: {
     			label: 'Last Name',
     			prompt: ''
     		},
            dob: {
     			label: 'Date of birth',
     			prompt: ''
     		},
            gender_id: {
     			label: 'Sex',
     			prompt: ''
     		},
			other_gender: {
				label: 'Other Gender',
				prompt: ''
			},
            school_id: {
     			label: 'UK School',
     			error: 'Either a UK School or Non-UK School should be provided',
     			prompt: 'The school which the child is a student of'
     		},
            non_uk_school_name: {
     			label: 'Other School (including non-UK schools)',
     			error: '',
     			prompt: 'If the child attends a non-UK school, or the school doesn\'t appear in the list, please write the school name here'
     		},
            swimming_ability_id: {
     			label: 'Swimming ability',
     			prompt: 'While swimming ability will be assessed by us on the child\'s first swimming session, please could you indicate which option best describes their current swimming ability'
     		},
			is_booking_for_rookie_academy: {
     			label: 'Is your child attending Rookie Academy (age 15-17)?',
            	prompt: ' '
     		},
     		tshirt_size_id: {
     			label: 'Specialist Programme T-Shirt Size (Rookie-only option)',
            	prompt: ' '
     		},
     		emergency_contact: {
     			label: 'Emergency Contact',
     			prompt: 'Please specify who to contact in an emergency when your child is on camp – ideally 2 sets of contact details with name, number and relationship to child'
     		},
            has_behaviour_issues: {
     			label: 'Behaviour Details',
     			prompt: ' Are there any details regarding behaviour that would be helpful for our coaching staff to be aware of? If so, please provide details below and a member of the team will be in touch to discuss how we can safely support and accommodate your child on camp. <br><br><div class="text-center"><strong><a href="https://www.kingscamps.org/wp-content/uploads/2022/01/Kings-Camps-Behaviour-Management-Framework.docx" target="_blank">Please click here to download a full copy of our Behaviour Management framework.</a></strong></div>'
     		},
     		behaviour_issue_details: {
     			label: 'Please provide details',
     			prompt: 'e.g. my child has been diagnosed with …. which can be displayed in..... usually triggered by......',
     		},
			parents_support_question: {
     			label: 'Additional Support',
     			prompt: 'Does your child require additional support during their attendance of camp?'
     		},
     		parents_support_notes: {
     			label: 'Please provide details',
     			prompt: '',
     		},
            needs_assistance: {
     			label: 'Special Educational Needs and Disabilities (SEND)',
				prompt: 'e.g. my child receives 1:1 support in school for…'
			},
            assistance_details: {
     			label: 'Please give a summary below',
				prompt: ''
			},
            has_medicial_issues: {
     			label: 'Medical Details',
				prompt: 'Does your child have any medical conditions we should be aware of, or medication they will need help with e.g. allergies, dietary requirements, diabetes, toilet requirements? Please complete this <a target="_blank" href="https://www.kingscamps.org/wp-content/uploads/2026/02/Medication-Auto-injector-Form-.pdf"> form</a> and bring it to camp on your first day.'
			},
            medical_issue_details: {
     			label: 'Please provide details, including any medication required',
				prompt: 'My child has Asthma, requires inhaler but can self-administer'
			},
            has_anaphylaxsis: {
     			label: 'Anaphylaxis',
				error: '',
				prompt: 'Does the participant have anaphylaxsis or will need needle injections (diabetes)?'
			},
            has_anaphylaxsis_agreement: {
     			label: 'Allergy Action Plan',
				prompt: 'Please complete this <a target="_blank" href="https://res.kingscamps.org/pdf/Medication_Auto_injector_Form_2023.pdf">medication form</a> and bring it to camp on your first day.'
			},
			has_allergies: {
     			label: 'Allergies',
				error: '',
				prompt: 'If other please outline allergy below'
			},
            allergy_details: {
     			label: 'Please provide details',
				prompt: 'My child has Hay fever but will take medication before camp, will have piriton on her during her attendance'
			},
            has_treatment_permission: {
     			label: 'Urgent Medical Treatment Permission',
				prompt: 'For all medication that requires prompts or administering from staff, a medical form will be required to be completed by parents/carers on day one of camp. Please note, Kings Camps staff cannot provide physical support with the application of cream. Please find the <a target="_blank" href="https://www.kingscamps.org/wp-content/uploads/2025/02/Medication-Auto-injector-Form-2025.pdf"> form</a>'
			},
            treatment_exceptions: {
     			label: 'Please list any exceptions',
				prompt: ''
			},
            doctor_details: {
     			label: 'Doctor Details',
				prompt: 'Please provide name of the doctor and surgery, address and contact number for this child.'
			},
			camp_notes: {
				label: 'Notes for the Camp Manager',
				prompt: 'Please input any additional information you would like Kings Camps to be aware of. E.g., Friend requests<br>Please note friend requests cannot be guaranteed but we will always try to accommodate requests where possible. Our group allocation is dependent on the ages and number of children on camp each week.'
			},
            has_swimming_session_permission: {
     			label: 'Swimming sessions',
				prompt: 'Do you give permission for your child to take part in swimming sessions (if available)?'
			},
            has_promotional_photography_permission: {
     			label: 'Photography',
				prompt: 'We sometimes take photos and videos for our website, literature and social media to show what happens on camp. Are you happy for your child to be included in those photos and videos?'
			},
            has_return_home_unaccompanied_permission: {
     			label: 'Return home unaccompanied',
				prompt: 'Do you give permission for your child to return home unaccompanied if they are aged 11 or over at the time of camp? (Note: children under the age of 11 must always be signed out by a registered adult)'
			},
            has_given_consent: {
     			label: 'Your consent',
				prompt: 'I understand and agree with the Kings Camps <a target="_blank" href="https://www.kingscamps.org/kings-camps-policies">terms and conditions</a>. Kings Camps work closely with local Registration, Inspection Units and external agencies. With their support we make every effort to ensure the safety of your child whilst in our care.<br><br>It is our duty to report any suspicion of abuse or neglect and therefore there may be occasions where Kings Camps may require to disclose your child’s information to these authorities due to safeguarding concerns. In these instances, we would rely on a legal obligation to process personal data and may not require your consent to share this information if an investigation is underway.'
			}
     	}
     }
}



// WEBPACK FOOTER //
// ./src/languages/locale-en.js